import React from 'react';
// import ExpandableListItem from '../../../../components/molecules/expandable_element';
import SearchIcon from '@material-ui/icons/Search';
import clsx from 'clsx';
import useStyles from './styles';
import FilterForm from './filter_form';
import TranslatedText from 'components/atoms/translated_text';
import { Translations } from '../../configuration';
import { Roles } from 'config';

interface IProps {
  statusCode: string | null;
  account: string | null;
  dateFrom: Date | null;
  dateTo: Date | null;
}

const Filter = (props: IProps) => {
  const classes = useStyles();
  const Header = () => {
    return (
      <div className={classes.filter_header} style={{ marginTop: '0.5rem' }}>
        <SearchIcon style={{ marginRight: '1rem' }} />
        <span style={{ fontSize: '1.2rem' }}>
          <TranslatedText textMap={Translations.search} />
        </span>
      </div>
    );
  };

  const Body = () => {
    return (
      <FilterForm
        account={props.account}
        statusCode={props.statusCode}
        dateFrom={props.dateFrom}
        dateTo={props.dateTo}
      />
    );
  };

  return (
    <div
      className={clsx({
        [classes.cardLayout]: true,
        [classes.filter]: true,
      })}
    >
      {/* <ExpandableListItem
        renderDataHeader={() => <Header />}
        renderDataBody={() => <Body />}
      /> */}
      <Header />
      <Body />
    </div>
  );
};

export default Filter;
